import { PermissionsGuard } from '../../../../store/guards/permissions.guard';
import { Permission } from '../../../constants/permissions';
import type { HeaderNavigation } from './header-navigation.types';
import { accountNavigationLoader } from './loaders/account-navigation.loader';
import { monitoringNavigationLoader } from './loaders/monitoring-navigation.loader';

export * from './header-navigation.types';

export const headerNavigation: HeaderNavigation = [
  {
    pathname: '/billing',
    label: 'Billing',
    prefixIcon: 'attach_money',
    ariaLabel: 'Navigate to billing',
    activators: [PermissionsGuard({ every: [Permission.BILLING_READ] })],
  },
  {
    alias: 'IQ',
    label: 'IQ Analytics',
    prefixIcon: 'insights',
    ariaLabel: 'IQ Analytics group',
    activators: [
      PermissionsGuard({
        every: [Permission.NITEL_IQ_PARTICIPANT],
      }),
    ],
    children: [
      {
        pathname: '/analytics/historical-observations',
        label: 'Historical Observations',
        ariaLabel: 'Navigate to historical observations',
      },
      {
        pathname: '/analytics/metric-details',
        label: 'Metric Details',
        ariaLabel: 'Navigate to metric details',
      },
      {
        pathname: '/analytics/quality-of-experience',
        label: 'Quality of Experience',
        ariaLabel: 'Navigate to quality of experience',
      },
      {
        pathname: '/analytics/unusual-network-metrics',
        label: 'Unusual Network Metrics',
        ariaLabel: 'Navigate to unusual network metrics',
      },
    ],
  },
  monitoringNavigationLoader,
  {
    pathname: '/orders',
    label: 'Orders',
    prefixIcon: 'check',
    ariaLabel: 'Navigate to orders',
    activators: [PermissionsGuard({ every: [Permission.ORDERS] })],
  },
  {
    pathname: '/services',
    label: 'Services',
    prefixIcon: 'directions_run',
    params: { groupBy: 'Location' },
    ariaLabel: 'Navigate to services',
    activators: [PermissionsGuard({ every: [Permission.SERVICES] })],
  },
  {
    pathname: '/tickets',
    label: 'Tickets',
    prefixIcon: 'build',
    params: { groupBy: 'Type' },
    ariaLabel: 'Navigate to tickets',
    activators: [PermissionsGuard({ every: [Permission.TICKETING_READ] })],
  },
];

export const accountNavigation: HeaderNavigation = [accountNavigationLoader];
